<template>
  <path
    d="M19 6.00018H5C3.9 6.00018 3 6.90018 3 8.00018V16.0002C3 17.1002 3.9 18.0002 5 18.0002H19C20.1 18.0002 21 17.1002 21 16.0002V8.00018C21 6.90018 20.1 6.00018 19 6.00018ZM18 16.0002H6C5.45 16.0002 5 15.5502 5 15.0002V9.00018C5 8.45018 5.45 8.00018 6 8.00018H18C18.55 8.00018 19 8.45018 19 9.00018V15.0002C19 15.5502 18.55 16.0002 18 16.0002Z"
  />
</template>
